import { groupBy } from 'lodash'
import { Box } from '@material-ui/core'
import React from 'react'
import { BarDatum } from '@nivo/bar'
import { calcMaxY } from './CalibrationLineChart'
import { CalibrationBarChart } from './CalibrationBarChart'
import { CustomSeries } from '../chart-util'

type Props = {
  energySystemData: CustomSeries[]
  measuredData: CustomSeries
  axisBottomLegend?: string
  axisLeftLegend?: string
  legendItemWidth?: number
  grouped?: boolean
  colors?: string[]
}

const ToBarDatums = (series: CustomSeries[]): BarDatum[] => {
  const datumIds = groupBy(series, (serie) => serie.data[0].x)

  const result: BarDatum[] = []

  const serieIds = Object.keys(datumIds)

  for (let i = 0; i < serieIds.length; i++) {
    const serieId = serieIds[i]

    const tempSeries = datumIds[serieId]

    const referenceXvalues = tempSeries[0].data.flatMap((d) =>
      d.x ? [d.x.toString()] : [],
    )

    referenceXvalues.forEach((_, index) => {
      result.push({ id: referenceXvalues[index] })
    })

    tempSeries.forEach((s) => {
      s.data.forEach((d) => {
        if (d.x && referenceXvalues.includes(d.x.toString())) {
          const datum = result.find((bd) => bd.id === d.x?.toString())
          if (datum && d.y) datum[s.id.toString()] = Number(d.y)
        }
      })
    })
  }

  return result
}

const getKeys = (series: CustomSeries[]): string[] => [
  ...new Set(series.map((s) => s.id.toString())),
]

export function BarGraphContent({
  energySystemData,
  measuredData,
  axisBottomLegend,
  axisLeftLegend,
  legendItemWidth,
  grouped,
  colors,
}: Props): React.ReactElement {
  const series =
    measuredData.data.length > 0
      ? [measuredData, ...energySystemData]
      : [...energySystemData]

  const measuredSerieId =
    measuredData.data.length > 0 ? measuredData.id.toString() : undefined

  const chartData = ToBarDatums(series)

  const keys = getKeys(series)

  const maxY = calcMaxY(series)

  const xValueFormatter = (id: string) => id

  return (
    <Box width="100%" height={540} borderRadius={6}>
      {chartData.length > 0 && (
        <CalibrationBarChart
          data={chartData}
          keys={keys}
          measuredSerieId={measuredSerieId}
          xFormatter={xValueFormatter}
          yFormatter={(value) => value.toString()}
          maxValue={maxY}
          axisBottomLegend={axisBottomLegend}
          axisLeftLegend={axisLeftLegend}
          legendItemWidth={legendItemWidth}
          grouped={grouped}
          colors={colors}
        />
      )}
    </Box>
  )
}
